module.exports = __webpack_public_path__ + "img/pocket-1_en.a83204d.jpg";